/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { telemetryListAttributeKeys } from "../funcs/telemetryListAttributeKeys.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListAttributeKeysResult } from "../models/components/listattributekeysresult.js";
import {
  ListAttributeKeysRequest,
  ListAttributeKeysSecurity,
} from "../models/operations/listattributekeys.js";
import { unwrapAsync } from "../types/fp.js";
export type ListAttributeKeysQueryData = ListAttributeKeysResult;

export function prefetchListAttributeKeys(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListAttributeKeysRequest,
  security?: ListAttributeKeysSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildListAttributeKeysQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildListAttributeKeysQuery(
  client$: GramCore,
  request: ListAttributeKeysRequest,
  security?: ListAttributeKeysSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ListAttributeKeysQueryData>;
} {
  return {
    queryKey: queryKeyListAttributeKeys({
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function listAttributeKeysQueryFn(
      ctx,
    ): Promise<ListAttributeKeysQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(telemetryListAttributeKeys(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyListAttributeKeys(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "telemetry", "listAttributeKeys", parameters];
}
